import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SkillContainer } from './SkillContainer';
import '../styles/hcHomepageStyles.css';
import comprehensionIcon from '../images/icon-comprehension.svg';
import fluencyIcon from '../images/icon-fluency.svg';
import phonemicIcon from '../images/icon-phonemic.svg';
import phonicsIcon from '../images/icon-phonics.svg';

export class SkillTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            containers: [
                {
                    id: 'phonemics',
                    image: phonemicIcon,
                },
                {
                    id: 'phonics',
                    image: phonicsIcon,
                },
                {
                    id: 'fluency',
                    image: fluencyIcon,
                },
                {
                    id: 'comprehension',
                    image: comprehensionIcon,
                },
            ],
        };
    }

    generateContainers = () => this.state.containers.map((container, index) =>
        (<SkillContainer
            key={`${container.id}_${index.toString()}`}
            id={index}
            trackerName={container.id}
            imgSrc={container.image}
            containerNames={this.props.containerNames[index]}
            activitiesTxt={this.props.activitiesTxt}
            activityAmounts={this.props.activityAmounts[index]}
            handleSkillClick={this.props.handleSkillClick}
            toolTipText={this.props.toolTipText[index]}
        />));


    render() {
        return (
            <div id="homepageActivityTable">
                {this.generateContainers()}
            </div>
        );
    }
}

SkillTable.propTypes = {
    containerNames: PropTypes.array.isRequired,
    activitiesTxt: PropTypes.string.isRequired,
    activityAmounts: PropTypes.array.isRequired,
    handleSkillClick: PropTypes.func.isRequired,
    toolTipText: PropTypes.array.isRequired,
};

export default SkillTable;



// WEBPACK FOOTER //
// ./src/components/SkillTable.jsx